import { render, staticRenderFns } from "./forgotPasswordDialog.vue?vue&type=template&id=4e952866"
import script from "./forgotPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./forgotPasswordDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports